import { Badge, Button, Group, Stack, Text, UnstyledButton } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { WeeklyHistory } from "@msc/shared";

import { kwLabel } from "../../lib/weekly.js";

export function WeeklyHistoryList({
  history,
  selectedId,
  onSelect,
  onCreate,
  creating,
}: {
  history: WeeklyHistory;
  selectedId: string | undefined;
  onSelect: (weeklyId: string) => void;
  onCreate: () => void;
  creating: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Stack gap="xs" w={{ base: "100%", sm: 220 }}>
      {history.canCreate && (
        <Button onClick={onCreate} loading={creating}>
          {t("weekly.create", { kw: kwLabel(t, history.currentWeek) })}
        </Button>
      )}
      <Text fw={600} size="sm">
        {t("weekly.history")}
      </Text>
      {history.items.length === 0 && (
        <Text size="sm" c="dimmed">
          {t("weekly.noHistory")}
        </Text>
      )}
      {history.items.map((w) => (
        <UnstyledButton key={w.id} onClick={() => onSelect(w.id)} fw={w.id === selectedId ? 700 : 400}>
          <Group gap="xs">
            <Text size="sm" fw="inherit">
              {kwLabel(t, w)}
            </Text>
            {w.status === "offen" && <Badge size="xs">{t("weekly.statusOpen")}</Badge>}
          </Group>
        </UnstyledButton>
      ))}
    </Stack>
  );
}
